import { render, staticRenderFns } from "./done.vue?vue&type=template&id=21f0fe8b&scoped=true"
import script from "./done.vue?vue&type=script&lang=js"
export * from "./done.vue?vue&type=script&lang=js"
import style0 from "./done.vue?vue&type=style&index=0&id=21f0fe8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0fe8b",
  null
  
)

export default component.exports